import React, { useState } from 'react';
import { Table, TablePaginationConfig, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TourTrashStatusType, TourTrashType } from '../../../types/tourtrash';
import { ActionsColumn, DateColumn, EmailColumn, IndexColumn, StatusColumn, TitleColumn, WinnerColumn } from './column';
import { TOUR_TRASH_TRANSLATION } from '../../../constants/define/translation';

const { Text } = Typography;

const { Column } = Table;

interface TourTrashListProps {
  records: TourTrashType[];
  loading: boolean;
  className?: string;
  onRefresh: () => void;
  onHandleViewTourtrash?: (record: TourTrashType) => void;
  onHandleClickBtnEdit?: (record: TourTrashType, editTourTrashActive?: boolean) => void;
  pagination?: TablePaginationConfig;
}

export const TourTrashTable = (props: TourTrashListProps) => {
  const { t } = useTranslation(TOUR_TRASH_TRANSLATION);
  const [isLoading, setIsLoading] = useState(false);
  const { pagination } = props;
  const setLoading = (value: boolean) => {
    setIsLoading(value);
  };

  return (
    <Table
      dataSource={props.records}
      loading={props.loading || isLoading}
      className={props.className}
      rowKey="id"
      pagination={pagination}
      summary={pageData => {
        return (
          <>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
              <Table.Summary.Cell index={0}>
                <Text>{props.records.length}</Text>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </>
        );
      }}
      scroll={{ x: 1450 }}
    >
      <Column
        title={t('table.title.index')}
        align="center"
        width={70}
        dataIndex="index"
        key="index"
        render={value => <IndexColumn value={value} />}
        fixed="left"
      />
      <Column
        align="center"
        title="Title"
        key="title"
        width={330}
        render={(_, record: TourTrashType) => (
          <TitleColumn record={record} onHandleClickBtnEdit={props.onHandleClickBtnEdit} setLoading={setLoading} />
        )}
        fixed="left"
      />
      <Column
        title={t('table.title.status')}
        key="status"
        dataIndex="status"
        render={(value: any, record: TourTrashType) => (
          <StatusColumn
            status={value}
            isActive={value && [TourTrashStatusType.ACTIVE, TourTrashStatusType.COMING_SOON].includes(value)}
            width="120px"
          />
        )}
        fixed="left"
      />
      <Column
        title={t('table.title.winner')}
        key="winner"
        render={(_, record: TourTrashType) => <WinnerColumn record={record} />}
      />
      <Column
        title={t('table.title.email')}
        key="winnerEmail"
        dataIndex="winnerEmail"
        render={(_, record: TourTrashType) => <EmailColumn email={record?.winner?.email} />}
        width="17%"
      />
      <Column
        title={t('table.title.startDate')}
        key="startDate"
        align="center"
        render={(_, record: TourTrashType) => (
          <DateColumn
            date={record.startDate}
            isHighlight={!record.winner && record.status !== TourTrashStatusType.CLOSED}
          />
        )}
        width="10%"
      />
      <Column
        title={t('table.title.endDate')}
        key="endDate"
        align="center"
        render={(_, record: TourTrashType) => (
          <DateColumn
            date={record.endDate}
            isHighlight={!record.winner && record.status !== TourTrashStatusType.CLOSED}
          />
        )}
        width="10%"
      />
      <Column
        title={t('table.title.action')}
        key="action"
        align="right"
        width={200}
        render={(_, record: TourTrashType) => (
          <ActionsColumn
            onRefresh={props.onRefresh}
            record={record}
            onHandleViewTourtrash={props.onHandleViewTourtrash}
            onHandleClickBtnEdit={props.onHandleClickBtnEdit}
            setLoading={setLoading}
          />
        )}
      />
    </Table>
  );
};
